export default __webpack_public_path__ + "static/bg_report_3-7662445e2239dbb11e0a32dde33acb32.webp";